<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          Upload files into folder <b class="text-primary">{{ model.name }}</b>
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <VueFileAgent
        ref="vueFileAgent"
        :theme="'default'"
        :multiple="true"
        :deletable="false"
        :meta="true"
        :linkable="true"
        :accept="
          'image/*,video/*,audio/*,.pdf,.doc,.docx,.ods,.csv, .xls, .xlsx, text/csv, application/csv, text/comma-separated-values, application/csv, application/excel, application/vnd.msexcel, text/anytext, application/vnd. ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain, .zip'
        "
        :maxSize="'50MB'"
        :maxFiles="14"
        :helpText="'Choose images or files'"
        :errorText="{
          type: 'Invalid file type.',
          size: 'Files should not exceed 50MB in size'
        }"
        @select="filesSelected($event)"
        v-model="fileRecords"
      ></VueFileAgent>
      <div class="row ts-mt-6">
        <div class="col-sm-12 col-lg-12 col-md-12 text-right">
          <ts-button @click.prevent="$emit('close')" :disabled="loading">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            :disabled="!fileRecordsForUpload.length || loading"
            @click.prevent="uploadFiles()"
            :waiting="loading"
            color="primary"
            class="ml-2"
          >
            Upload {{ fileRecordsForUpload.length }} files
          </ts-button>
        </div>
      </div>
    </ts-card-wrapper>
  </div>
</template>
<script>
import Vue from 'vue'
import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'
Vue.use(VueFileAgent)
import { forEach } from 'lodash'
import httpClient from '@/http-client'

export default {
  name: 'uploadFilesPopup',
  props: ['data'],
  data: function () {
    return {
      loading: false,
      model: {},
      fileRecords: [],
      uploadUrl: process.env.VUE_APP_PROXY + '/api/upload-files',
      uploadHeaders: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-Test-Header': 'vue-file-agent',
        Authorization: 'Bearer ' + this.$store.state.accessToken
      },
      fileRecordsForUpload: [] // maintain an upload queue
    }
  },
  created () {
    this.model = this.data
  },
  methods: {
    uploadFiles: function () {
      this.loading = true
      this.successCreate = []
      // Using the default uploader. You may use another uploader instead.
      forEach(this.fileRecordsForUpload, f => {
        let frm = new FormData()
        frm.append('file', f.file)
        frm.append('filename', f.file.name)
        // frm.append('path', '/')
        frm.append('parent_id', this.data.id)
        frm.append('extension', f.ext)
        frm.append('is_last', true)
        httpClient
          .post('/api/upload-files', frm, {
            onUploadProgress: el => {
              if (el.lengthComputable) {
                f.progressing = Math.round((el.loaded * 100) / el.total)
              }
            }
          })
          .then(() => {
            this.successCreate.push(f)
            if (
              this.fileRecordsForUpload.length === this.successCreate.length
            ) {
              this.$emit('close')
              this.$emit('before-close')
            }
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        fileRecord => !fileRecord.error
      )
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      )
    }
  }
}
</script>
